var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import gql from "graphql-tag";
import { graphql } from "react-apollo";
// import { graphql } from "react-apollo";
// import {
//   FindAddressesQuery_findAddresses,
//   FindAddressesQuery
// } from "../../../schemaTypes";
// finds all addresses submitted by ALL users
export var findUserQuery = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query FindUserQuery {\n    findUser {\n      email\n      id\n      forename\n      surname\n      dob\n      screeningPassed\n      paymentsAuthorised\n      mfaEnabled\n      userAuthTier\n      pushToken\n      country\n      xtag\n      payRef\n      default_receiving_wallet_id\n    }\n  }\n"], ["\n  query FindUserQuery {\n    findUser {\n      email\n      id\n      forename\n      surname\n      dob\n      screeningPassed\n      paymentsAuthorised\n      mfaEnabled\n      userAuthTier\n      pushToken\n      country\n      xtag\n      payRef\n      default_receiving_wallet_id\n    }\n  }\n"])));
// export HOC
export var withFindUser = graphql(findUserQuery, {
    props: function (_a) {
        var data = _a.data;
        var user;
        if (data && !data.loading && data.findUser) {
            user = data.findUser;
        }
        else {
            throw new Error("Something is wrong (FindUser Failed)");
        }
        return { user: user, loading: data ? data.loading : false };
    },
});
var templateObject_1;
//# sourceMappingURL=index.js.map